<template>
  <div class="apply_box">
    <div class="top">为了避免影响您的个人信用记录，请按时还款</div>
    <div class="con">
      <div class="box">
        <p class="title">
          <img class="logo"
               :src="list.icon" />
          <span>{{ list.productName }}</span>
        </p>
        <div class="pro_detail">
          <div class="header">
            <p class="loanTitle">借款金额(元)</p>
            <p class="money">￥{{ list.amount }}.00</p>
          </div>
          <div class="pro_item"
               v-for="(item, index) in content"
               :key="index">
            <p>{{ item.title }}</p>
            <p :class="{ status_btn: item.type == 1 }">{{ item.rightTitle }}</p>
          </div>
          <div class="pro_item">
            <p>还款计划</p>
            <p class="look"
               @click="toHide">
              {{ btnText
            }}<span class="look_up"
                    :class="{ look_down: !isShow }"></span>
            </p>
          </div>
          <div class="pro_item1"
               v-show="isShow"></div>
          <div class="limit"
               v-show="isShow">
            <Timeline>
              <Timeline-item v-for="(itm, idx) in plans"
                             :key="idx">
                <span class="icon_end"></span>
                <div class="box">
                  <p class="time"
                     :class="{ gray: itm.repay == 1 }">
                    {{ itm.order }}
                  </p>
                  <p class="content">
                    <span class="date"
                          :class="{ gray: itm.repay == 1 }">{{ itm.repayTime }}</span><span class="stateText"
                          :class="{ gray: itm.repay == 1 }">还款金额 {{ itm.repayamount }}元</span>
                  </p>
                </div>
              </Timeline-item>
            </Timeline>
          </div>
        </div>
        <div class="btn_box">
          <div class="loan_btn pay_btn_succ"
               @click="toPage(buttonJson.pageUrl)">
            {{ buttonJson.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      orderId: "",
      isShow: false,
      btnText: "查看详情",
      list: [],
      content: [],
      plans: [],
      buttonJson: {}
    };
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title("还款详情");
    this.getDetail();
  },
  methods: {
    toHide () {
      this.isShow = !this.isShow;
      if (!this.isShow) {
        this.btnText = "查看详情";
      } else {
        this.btnText = "收起详情";
      }
    },
    toPage (pageUrl) {
      window.location.href = pageUrl;
    },
    getDetail () {
      let _this = this;
      this.$get("/app/api/v1/order/repay/" + this.orderId, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            this.list = e.data;
            this.content = e.data.info.contents;
            this.plans = e.data.repayPlans.plans;
            this.buttonJson = e.data.button;
          } else {
            _this.util.toast({ msg: e.msg });
          }
        })
        .catch(error => { });
    }
  }
};
</script>
<style scoped>
.apply_box {
  /* margin: 0.1rem; */
  background: #f7f7f7;
}
.con {
  padding: 0.1rem;
}
.top {
  background: #e6ebff;
  width: 100%;
  height: 0.36rem;
  line-height: 0.36rem;
  text-align: center;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #5983fc;
}
.box {
  width: 100%;
  margin: 0 auto;
  font-size: 0.14rem;
  color: #333;
}
.pro_detail {
  background: #fff;
  position: relaitve;
  top: -1px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding-bottom: 0.1rem;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.pro_item {
  padding: 0.05rem 0.14rem;
  color: #666;
  /* border-bottom: 1px solid #eee; */
  display: flex;
  flex: 1;
  justify-content: space-between;
  height: 0.34rem;
  line-height: 0.25rem;
}
.pro_item1 {
  border-bottom: 1px solid #eee;
  margin: 0.15rem;
}
.btn {
  color: #ffffff;
  font-size: 0.17rem;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.2rem;
}
.pro_item .look {
  color: #486cff;
  font-size: 0.14rem;
  float: right;
}
.look_up,
.look_down {
  display: inline-block;
  width: 0.11rem;
  height: 0.13rem;
  background: url('../../assets/img/afterLoan/look_up.png') no-repeat top center;
  background-size: 100% 100%;
  position: relative;
  top: 0.025rem;
  margin-left: 0.05rem;
}
.look_down {
  background: url('../../assets/img/afterLoan/look_down.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.logo {
  display: inline-block;
  width: 0.22rem;
  height: 0.22rem;
  /* background: url("../../assets/img/vip/myVip_bg1.png") no-repeat top center;
  background-size: 100% 100%; */
  position: relative;
  top: 0.04rem;
  margin-right: 0.08rem;
}

.title {
  font-size: 0.16rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 0.9rem;
  background: url('../../assets/img/afterLoan/toast_bg.png') no-repeat center
    center;
  background-size: 100% 100%;
  padding-top: 0.13rem;
}
.header {
  text-align: center;
  font-size: 0.12rem;
  color: #999;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.2rem;
  margin: 0 0.15rem;
  margin-bottom: 0.2rem;
}
.money {
  font-size: 0.35rem;
  font-family: DINAlternate-Bold;
  font-weight: bold;
  color: #333;
}
.pro_item .status_btn {
  background: rgba(255, 230, 212, 1);
  border-radius: 13px;
  font-size: 0.14rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  line-height: 20px;
  padding: 0.02rem 0.1rem;
  color: #ff6a48;
}
.pro_item p {
  font-size: 0.14rem;
  color: #666;
}

.limit {
  padding: 0 0.15rem;
}
</style>
<style>
.ivu-timeline-item:last-child {
  padding-bottom: 0;
}
.ivu-timeline-item-head {
  width: 5px;
  height: 5px;
  background-color: #fff;
  border-radius: 50%;
  /* border: 1px solid transparent; */
  position: absolute;
  background: #486cff;
  left: 4px;
}
.ivu-timeline-item-tail {
  border-left: 1px solid #486cff;
}
.ivu-timeline-item-content {
  font-size: 0.14rem;
  color: #333;
}
.box {
  position: relative;
}
.date {
  color: #999;
}
.stateText {
  position: absolute;
  right: 0;
  top: 0.1rem;
  font-size: 0.14rem;
  color: #333;
}
.gray {
  color: #999;
}
.btn_box {
  margin-top: 0.3rem;
}

.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.5) 0%,
    rgba(81, 117, 241, 0.5) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
}

.pay_btn_succ {
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.8) 0%,
    rgba(81, 117, 241, 1) 100%
  );
}
</style>
